import React from 'react';
import './App.css';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import UnifiedDashboard from './pages/UnifiedDashboard';
import { ThemeProvider } from './components/ThemeProvider';


// Helper to get user role from localStorage
function getUserRole() {
  const user = localStorage.getItem('user');
  if (!user) return null;
  try {
    return JSON.parse(user).role;
  } catch {
    return null;
  }
}


// ProtectedRoute component
function ProtectedRoute({ element, allowedRoles }) {
  const role = getUserRole();
  if (!role) return <Navigate to="/" />;
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/dashboard" />;
  return element;
}

function App() {
  return (
    <ThemeProvider>
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--theme-wash, #f8f9fa)' }}>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<ProtectedRoute element={<UnifiedDashboard />} allowedRoles={["Admin","Doctor","Receptionist","Pharmacy","Therapist","Finance","HR"]} />} />
        </Routes>
      </Router>
    </div>
    </ThemeProvider>
  );
}

export default App;
